import $ from "jquery";

const htmlEdit = (editor) => {

    const pfx = editor.getConfig().stylePrefix;
    const modal = editor.Modal;
    const codeViewer = editor.CodeManager.getViewer('CodeMirror').clone();
    const container = document.createElement('div');
    const btnEdit = document.createElement('button');
    btnEdit.setAttribute('id', 'updateDataBtn');

    codeViewer.set({
        codeName: 'htmlmixed',
        readOnly: 0,
        theme: 'hopscotch',
        autoBeautify: true,
        autoCloseTags: true,
        autoCloseBrackets: true,
        lineWrapping: true,
        styleActiveLine: true,
        smartIndent: true,
        indentWithTabs: true
    });
    

    $(btnEdit).html(`Update data`)
    //  &nbsp;<i id='Loader' style='': none' class="fa fa-circle-o-notch fa-spin" ></i>
    btnEdit.className = `${pfx}btn-prim ${pfx}btn-import`;
    btnEdit.onclick = () => {
            
        const code = codeViewer.editor.getValue();
        editor.DomComponents.getWrapper().set('content', '');
        editor.setComponents(code.trim());

        modal.close();
    };

    editor.Commands.add('html-edit', {
        run: () => {
    
            const commands = editor.Commands;     
            if(commands.isActive('view-annotations') === false){

                let viewer = codeViewer.editor;
                modal.setTitle('Edit code');
                if (!viewer) {
                    const txtarea = document.createElement('textarea');
                    container.appendChild(txtarea);
                    container.appendChild(btnEdit);
                    codeViewer.init(txtarea);
                    viewer = codeViewer.editor;
                }
                const InnerHtml = editor.getHtml();
                const Css = editor.getCss();
                modal.setContent('');
                modal.setContent(container);
                codeViewer.setContent(`${InnerHtml}<style>${Css}</style>`);
                modal.open();
                viewer.refresh();
            }
        },
    });

}

export default htmlEdit;